export const routeMeta = {
    "/dashboard": { title: "Dashboard", pageTitle: "Home" },
    "/time-and-attendance": { title: "Time & Attendance", pageTitle: "SS White" },
    "/accounting": { title: "Accounting", pageTitle: "Departments" },
    "/engineering": { title: "Engineering", pageTitle: "Departments" },
    "/humanresource": { title: "Human Resource", pageTitle: "Departments" },
    "/epo": { title: "EPO", pageTitle: "Operations" },
    "/mafia": { title: "Quality/Production Auxiliary", pageTitle: "Display Boards" },
    "/document-management": { title: "Document Management System", pageTitle: "DMS" },
    "/dms/edit/:docType/:id": { title: "Edit DMS", pageTitle: "DMS" },
    "/dms/create/:docType": { title: "Create DMS", pageTitle: "DMS" },


    "/task-management": { title: "Task Management", pageTitle: "TaskManagement" },
    "/task-management/create": { title: "Create New Task", pageTitle: "TaskManagement" },
    "/task-management/view-task/:taskId": { title: "Task Details", pageTitle: "TaskManagement" },
    "/organizational-chart": { title: "Organization Chart", pageTitle: "Org Chart" },
    "/attendance": { title: "Personal Attendance", pageTitle: "Attendance" },
    "/visitors": { title: "Expected Visitors", pageTitle: "Dashboards" },
    "/contract-review": { title: "Contract Review", pageTitle: "Contract Review" },
    "/contract-review/new": { title: "Create New Contract Review", pageTitle: "Contract Review" },
    "/contract-review/:id": { title: "Contract Review Details", pageTitle: "Contract Review" },
    "/display-boards": { title: "Display Board", pageTitle: "Display Boards" },
    "/attendance/punch-records": { title: "My Time Punch Records", pageTitle: "Attendance" },
    "/attendance/whos-in-building": {
        title: "Who's In The Building?",
        pageTitle: "Attendance"
    },
};

